import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../services/authService";

export default function Login() {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {

        e.preventDefault();

        setError("");

        if (!email || !password) {
            setError("Please enter email and password.");
            return;
        }

        try {

            setLoading(true);

            const data = await login(email, password);

            console.log("Login successful:", data);

            navigate("/dashboard");

        } catch (err) {

            console.error("Login failed:", err);

            if (err.response) {

                if (err.response.status === 401) {
                    setError("Invalid email or password.");
                } else {
                    setError(
                        err.response.data?.message ||
                        "Login failed. Please try again."
                    );
                }

            } else {
                setError(
                    "Unable to connect to server. Please check your internet connection."
                );
            }

        } finally {

            setLoading(false);

        }

    };

    return (

        <div className="container-fluid vh-100">

            <div className="row h-100">

                <div className="col-md-7 login-left">

                    <h1>Potech Invoice</h1>

                    <p>
                        Professional Invoice Management System
                    </p>

                </div>

                <div className="col-md-5 d-flex justify-content-center align-items-center">

                    <div className="login-box">

                        <h3 className="mb-4">
                            Admin Login
                        </h3>

                        {error && (
                            <div className="alert alert-danger">
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>

                            <input
                                type="email"
                                className="form-control mb-3"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoComplete="email"
                            />

                            <input
                                type="password"
                                className="form-control mb-3"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="current-password"
                            />

                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled={loading}
                            >

                                {loading ? "Logging in..." : "Login"}

                            </button>

                        </form>

                    </div>

                </div>

            </div>

        </div>

    );

}
